import { useCallback } from 'react';
import { posthogTrackEvent, ReportEvents } from '@/assets/posthog';

export const useReportsTracking = () => {
  const trackReportGenerated = useCallback((reportType: string, reportParams?: Record<string, any>) => {
    posthogTrackEvent({
      event: ReportEvents.REPORT_GENERATED,
      properties: {
        reportType,
        ...reportParams,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackReportViewed = useCallback((reportId: string, reportType: string) => {
    posthogTrackEvent({
      event: ReportEvents.REPORT_VIEWED,
      properties: {
        reportId,
        reportType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackReportExported = useCallback((reportType: string, exportFormat: string) => {
    posthogTrackEvent({
      event: ReportEvents.REPORT_EXPORTED,
      properties: {
        reportType,
        exportFormat,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackReportShared = useCallback((reportType: string, shareMethod: string) => {
    posthogTrackEvent({
      event: ReportEvents.REPORT_SHARED,
      properties: {
        reportType,
        shareMethod,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackReportFiltered = useCallback((filterType: string, filterValue: any) => {
    posthogTrackEvent({
      event: ReportEvents.REPORT_FILTERED,
      properties: {
        filterType,
        filterValue,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackReportDateRangeChanged = useCallback((dateRange: { from: string; to: string }) => {
    posthogTrackEvent({
      event: ReportEvents.DATE_RANGE_CHANGED,
      properties: {
        dateFrom: dateRange.from,
        dateTo: dateRange.to,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  return {
    trackReportGenerated,
    trackReportViewed,
    trackReportExported,
    trackReportShared,
    trackReportFiltered,
    trackReportDateRangeChanged,
  };
};